export class GenericFields{
  codeSyncro: string = "";
  isDeleted: boolean = false;
}
